var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { FieldText } from '@dixa/lib-shared-habla';
import { useCallback } from 'react';
export const MISSING_TITLE_ERROR = 'Please add a name to this file';
export var TitleError;
(function (TitleError) {
    TitleError[TitleError["MissingTitle"] = 0] = "MissingTitle";
})(TitleError || (TitleError = {}));
export const ErrorMap = {
    [TitleError.MissingTitle]: MISSING_TITLE_ERROR,
};
export function TitleInput(_a) {
    var { value, errorCode, onChange: onChangeCallback } = _a, otherProps = __rest(_a, ["value", "errorCode", "onChange"]);
    const error = ErrorMap[errorCode !== null && errorCode !== void 0 ? errorCode : ''];
    const onChange = useCallback((event) => {
        if (!event) {
            return;
        }
        const { target: { value }, } = event;
        onChangeCallback(value);
    }, [onChangeCallback]);
    return (_jsx(FieldText, Object.assign({}, otherProps, { label: "Title", placeholder: "E.g. Welcome announcement", input: { name: 'title', value, onChange }, meta: { error } })));
}
